<template>
  <!-- Modal -->
  <div class="modal fade" id="InvoiceFileModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{translations('common.addition')}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="custom-file">
            <input @change="processFile($event)" type="file" class="custom-file-input" id="customFile" ref="customFile" accept="application/pdf">
            <label class="custom-file-label" for="customFile">{{fileLabel}}</label>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeFileModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{translations('common.close')}}</button>
          <button type="button" class="btn btn-primary" @click="addPoFile()">{{translations('common.update')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InvoiceFileModal',
  props: {},
  components: {
  },
  data () {
    return {
      tempPoFile: null,
      fileLabel: 'ファイルを選択'
    }
  },
  created () {
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    processFile (event) {
      if (event.target.files[0] === undefined) {
        this.tempPoFile = null
        this.fileLabel = 'ファイルを選択'
        return
      }
      const file = event.target.files[0]
      this.fileLabel = file.name
      const reader = new FileReader()
      const $this = this
      reader.onloadend = function () {
        $this.tempPoFile = reader.result
      }
      reader.readAsDataURL(file)
    },

    addPoFile () {
      if (this.tempPoFile === null) {
        this.$toastr.warning('ファイルを選択してください', 'ウォーニング')
        return
      }

      this.$parent.invoiceFile = this.tempPoFile
      this.tempPoFile = null // REFRESH
      this.$refs.customFile.value = []
      this.fileLabel = 'ファイルを選択'
      this.$refs.closeFileModal.click()
    }
  }
}
</script>
